module.exports = __webpack_public_path__ + "img/Riaz.e01eb7b6.jpg";